import React from 'react'
import '../../../client/theme.scss'
import '../../../client/app.scss'
import '../../../client/swiper.bundle.scss'
import BaseLayout from '../../../client/layout/base-layout'

import { IntlProvider } from 'react-intl'
import { getMessage, getLocale } from '../../../i18n'
import { useSelector } from 'react-redux'

import Thanks from '../../../client/pages/shoppingcart/pages/thanks'

import SwiperCore, {
	Pagination,
	Autoplay
} from 'swiper'
import { Route, Switch } from 'react-router-dom'

SwiperCore.use([Pagination, Autoplay])


const Index = props => {

	const global = useSelector((state) => state.global)

	return <IntlProvider messages={getMessage(global.language)} locale={getLocale(global.language)} defaultLocale="en">
		<Switch>
			<BaseLayout>
				<Route path={'/order-confirm/:transactionId'} exact component={Thanks} />
			</BaseLayout>
		</Switch>

		<div id="alert-container"></div>
		<div id="confirm-container"></div>
		<div id="toast-container"></div>

	</IntlProvider>

}


export default Index